<template>
  <div class="on-live" @click="handle2Active">
    <img v-if="online.pic" :src="$isCdn(online.pic)" alt="" />
    <img v-else src="@/assets/image/rec_1.png" alt="" />
    <div class="live-info">
      <div class="title van-ellipsis">{{ online.name }}</div>
      <div class="date" v-if="showDate">{{ online.createTime | formatDate('yyyy-MM-dd') }}</div>
      <div class="time" :class="{'current': !showDate}">
        <span>{{ online.userName }}</span>
        <span>{{ online.visitCount }}观看</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  // props: ['online', 'showDate'],
  props: {
    online: {
      type: Object
    },
    showDate: {
      type: Boolean,
      default: true
    },
    isWenxuan: {
      type: Number,
      default: 0
    }
  },
  methods: {
    handle2Active() {
      if (this.online.type === '1') {
        return this.$router.push(`/resourcePlay/${this.online.id}`)
      }
      this.$router.push(`/play/${this.online.id}?isWenxuan=${this.isWenxuan}`)
    }
  }
}
</script>

<style lang="scss" scoped>
.on-live {
  width: 164px;
  border-radius: 6px;
  background: #fff;
  overflow: hidden;
  margin-bottom: 16px;
  img {
    width: 100%;
    height: 92px;
  }
  .live-info {
    // height: 100px;
    padding: 8px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .date {
      font-size: 12px;
      color: #909399;
      padding: 10px 0;
    }
    .title {
      color: #303133;
      font-weight: 500;
      font-size: 14px;
    }
    .time {
      color: #909399;
      font-size: 12px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      &.current {
        margin-top: 8px;
      }
    }
    .time span:nth-child(2) {
      margin-left: 10px;
    }
  }
}
</style>
